/**
 * Normalizes a string by removing accents, converting to lowercase,
 * and removing special characters for better search matching.
 * 
 * @param str - The string to normalize
 * @returns The normalized string
 * 
 * @example
 * normalizeString("José María") // "jose maria"
 * normalizeString("Ángel") // "angel"
 * normalizeString("François") // "francois"
 */
export function normalizeString(str: string): string {
  if (!str) return "";
  
  return str
    .toLowerCase()
    .normalize("NFD") // Decompose characters into base + combining marks
    .replace(/[\u0300-\u036f]/g, "") // Remove combining diacritical marks (accents)
    .trim();
}
